import React from 'react';

const ML_Scatter_Plots = () => {
    return (
        <div>ML_Scatter_Plots Component</div>
    );
}

export default ML_Scatter_Plots;
